import { render, staticRenderFns } from "./CalendarWork.vue?vue&type=template&id=695142c2&"
import script from "./CalendarWork.vue?vue&type=script&lang=js&"
export * from "./CalendarWork.vue?vue&type=script&lang=js&"
import style0 from "./CalendarWork.vue?vue&type=style&index=0&id=695142c2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports